import React from "react";
import "./DeepCleaningHero.css";
import Navbar from "../../Header/Navbar";
import { Link } from "react-router-dom";

const DeepCleaningHero = () => {
  return (
    <>
      <Navbar />

      {/* HERO SECTION */}
      <section className="deep-mini-hero">
        <div className="deep-mini-container">

          {/* Title */}
          <h1 className="deep-mini-title">Deep Cleaning Services</h1>

          {/* Breadcrumb */}
          <p className="deep-mini-breadcrumb">
            <Link to="/" className="deep-mini-link">Home</Link>
            <span>-</span>

            <Link to="/services" className="deep-mini-link">Our Services</Link>
            <span>-</span>

            <Link
              to="/corporate-deepcleaningcorporate"
              className="deep-mini-link"
            >
              Deep Cleaning Services
            </Link>
          </p>

        </div>
      </section>

      {/* TAG BELOW HERO */}
    
    </>
  );
};

export default DeepCleaningHero;
